import React from "react";
import { AiOutlineMail, AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import { FaFacebookSquare } from "react-icons/fa";
import { BsStackOverflow } from "react-icons/bs";

function ProfileImage() {
  return (
    <div className="aiCol">
      <div className="section1">
        <img
          className="profileImg"
          src="https://www.w3schools.com/tags/img_girl.jpg"
          alt="example"
        ></img>
      </div>
      <h1 className="section1h1">Alex Smith</h1>

      <div className="iconCon">
        {[
          { icon: <AiOutlineMail /> },
          { icon: <AiFillGithub /> },
          { icon: <AiFillLinkedin /> },
          { icon: <FaFacebookSquare /> },
          { icon: <BsStackOverflow /> },
        ].map((item) => {
          return (
            <div className="iconStyle">
              <a className="icon">{item?.icon}</a>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ProfileImage;
